import {isNil} from 'ramda';

import {buildAuthHeader} from './buildAuthHeader';

const EMPTY_PAYLOAD = 'e30=';

export const buildWebSocketUrl = (): string | null => {
  const authHeader = buildAuthHeader();
  const appSyncUrl = process.env.APPSYNC_URL;

  if (isNil(appSyncUrl) || isNil(authHeader)) {
    console.error('AppSync URL or auth header is not found');
    return null;
  }

  const headerBase64 = btoa(JSON.stringify(authHeader));
  const wsUrl = appSyncUrl
    .replace('https://', 'wss://')
    .replace('appsync-api', 'appsync-realtime-api');

  return `${wsUrl}/realtime?header=${headerBase64}&payload=${EMPTY_PAYLOAD}`;
};
